import React from 'react';

/**
 * Confirmation modal for disconnecting Google account (Gmail & Calendar)
 * Shows warning about losing sync capability
 */
const DisconnectGmailModal = ({ isOpen, onClose, onConfirm, isDisconnecting, gmailEmail }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card-dark border border-card-border rounded-xl shadow-2xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-card-border">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-red-500/10 border border-red-500/20">
              <span className="material-symbols-outlined text-red-500 text-2xl">warning</span>
            </div>
            <h2 className="text-xl font-bold text-white">Disconnect Google Account?</h2>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-slate-300 leading-relaxed">
            Are you sure you want to disconnect your Google account? This will stop syncing both Gmail and Calendar.
          </p>

          {gmailEmail && (
            <div className="flex items-center gap-2 p-3 rounded-lg bg-slate-700/30 border border-slate-700">
              <span className="material-symbols-outlined text-slate-400 text-[20px]">account_circle</span>
              <span className="text-sm text-slate-300 font-medium">{gmailEmail}</span>
            </div>
          )}

          <div className="p-4 rounded-lg bg-yellow-500/5 border border-yellow-500/20">
            <div className="flex gap-3">
              <span className="material-symbols-outlined text-yellow-500 text-[20px] mt-0.5">info</span>
              <div className="flex flex-col gap-1">
                <p className="text-sm text-yellow-200 font-medium">This will:</p>
                <ul className="text-sm text-yellow-100/80 space-y-1 list-disc list-inside">
                  <li>Stop syncing emails with your CRM contacts</li>
                  <li>Stop syncing calendar events and meetings</li>
                  <li>Remove stored access credentials</li>
                  <li>Require re-authentication to reconnect</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-card-border flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isDisconnecting}
            className="px-4 py-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-700/50 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDisconnecting}
            className="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isDisconnecting ? (
              <>
                <span className="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
                Disconnecting...
              </>
            ) : (
              <>
                <span className="material-symbols-outlined text-[18px]">link_off</span>
                Disconnect
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisconnectGmailModal;
